import * as yup from 'yup';
import { Dayjs } from 'dayjs';
import { t } from 'i18next';

export const travelCostSettingsSchema = yup.object({
  active: yup.boolean(),
  distance_type: yup.string(),
  travel_exp_max_interval: yup
    .mixed<Dayjs>()
    .required(t('travelCost.required')),
  retrieve_distances: yup.boolean(),
  travel_movements_activation_date: yup
    .date()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' ? null : value))
    .test(
      'is-first-of-month',
      t('travelCost.mustBeFirstOfMonth'),
      (value) => value == null || value.getDate() === 1
    ),
  username: yup.string(),
  password: yup.string()
});
